import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { PrinterConfig, VariableData } from '@/types'

interface SettingsState {
  printer: PrinterConfig
  showGrid: boolean
  gridSize: number // in mm
  zoom: number // 1 = 100%
  variableData: VariableData
  lastClickPosition: { x: number; y: number } // Last click position in mm
  propertiesPanelHeight: number // Height in pixels

  setPrinter: (printer: PrinterConfig) => void
  setShowGrid: (show: boolean) => void
  setGridSize: (size: number) => void
  setZoom: (zoom: number) => void
  setVariableData: (data: VariableData) => void
  updateVariable: (key: string, value: string) => void
  setLastClickPosition: (x: number, y: number) => void
  setPropertiesPanelHeight: (height: number) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      printer: {
        ip: '192.168.1.100',
        port: 9100,
        connectionType: 'tcp',
      },
      showGrid: true,
      gridSize: 1, // 5mm grid
      zoom: 1,
      variableData: {},
      lastClickPosition: { x: 10, y: 10 }, // Default position
      propertiesPanelHeight: 200, // Default 200px

      setPrinter: (printer) => set({ printer }),
      setShowGrid: (showGrid) => set({ showGrid }),
      setGridSize: (gridSize) => set({ gridSize }),
      setZoom: (zoom) => set({ zoom }),
      setVariableData: (variableData) => set({ variableData }),
      updateVariable: (key, value) =>
        set((state) => ({
          variableData: { ...state.variableData, [key]: value },
        })),
      setLastClickPosition: (x, y) => set({ lastClickPosition: { x, y } }),
      setPropertiesPanelHeight: (height) => set({ propertiesPanelHeight: Math.max(100, Math.min(500, height)) }),
    }),
    {
      name: 'zpl-settings',
      partialize: (state) => ({
        printer: state.printer,
        showGrid: state.showGrid,
        gridSize: state.gridSize,
        zoom: state.zoom,
        variableData: state.variableData,
        propertiesPanelHeight: state.propertiesPanelHeight,
        // Don't persist lastClickPosition - reset on page load
      }),
    }
  )
)
